export default __webpack_public_path__ + "static/media/sirenas.b243905b.pdf";